import { combineReducers } from 'redux';

import { pendingDepositsReducer } from './pendingDeposits';

export const balancesReducer = combineReducers({
  pendingDeposits: pendingDepositsReducer,
});
